// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iE0c","controls":"styles_controls__2PZ9W","charLimit":"styles_charLimit__1uy5p","input":"styles_input__12TQQ","send":"styles_send__33y6q"};